const contentful = require("contentful");
const contentfulUrl = "https://graphql-contentful.lululemon.com/content/v1";
// eslint-disable-next-line import/no-default-export

class ContentfulClient {
  constructor({
    accessToken,
    environmentId = "master",
    host = "cdn-contentful.lululemon.com",
    isPreviewEnabled = false,
    locale = "en-US",
    previewToken,
    removeUnresolved = true,
    spaceId,
    base64CrossSpaceToken
  } = {}) {
    this.addCrossSpaceTokenHeader = headers => {
      if (base64CrossSpaceToken) {
        headers["x-contentful-resource-resolution"] = base64CrossSpaceToken;
      }
      return headers;
    };
    const baseOptions = {
      accessToken,
      environment: environmentId,
      host,
      withoutUnresolvableLinks: removeUnresolved,
      space: spaceId
    };
    baseOptions.headers = this.addCrossSpaceTokenHeader({});
    this.options = isPreviewEnabled && previewToken ? {
      ...baseOptions,
      accessToken: previewToken,
      host: "preview-contentful.lululemon.com"
    } : baseOptions;
    this.client = contentful.createClient(this.options);
    this.locale = locale;
  }
  getFilteredEntries({
    contentType,
    depth = 10,
    slug,
    filters = {}
  }) {
    const slugFilter = {};
    if (slug) {
      slugFilter["fields.slug"] = slug;
    }
    return this.client.getEntries({
      content_type: contentType,
      include: depth,
      locale: this.locale,
      ...slugFilter,
      ...filters
    });
  }
  async graphql({
    query,
    variables
  }) {
    const endpoint = `${contentfulUrl}/spaces/${this.options.space}/environments/${this.options.environment}`;
    const headers = this.addCrossSpaceTokenHeader({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.options.accessToken}`
    });
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          query,
          variables
        })
      });
      if (response.ok) {
        return response.json().then(result => {
          if (result.errors) {
            // eslint-disable-next-line no-console
            console.warn(`GraphQLErrors: ${result.errors.map(({
              message
            }) => message).join("\n")}`);
          }
          return result;
        });
      }
      const requestError = new Error(response.statusText);
      requestError.response = response;
      throw requestError;
    } catch (error) {
      throw new Error(`Error encountered querying ${contentfulUrl}: ${error.message}`);
    }
  }
}

export { ContentfulClient };
//# sourceMappingURL=index.js.map
